module.exports = __webpack_public_path__ + "static/media/add-message.2747368f.svg";